<p-tree [value]="items" selectionMode="checkbox" [(selection)]="selectedItems" [propagateSelectionDown]="false" [propagateSelectionUp]="false" (onNodeSelect)="itemSelected($event);"
    (onNodeUnselect)="itemUnSelected($event);">
</p-tree>